export default __webpack_public_path__ + "static/7_striker-nightcap-e3498f7a5815e9344a4bd7dd0ecf81a5.png";